export class LogSettings {
    constructor(
        data={
            id: -1,
            board_id: -1,
            intro: false,
            unit: '$',
            unit_suffix: false,
            should_tally: false,
            tally: -1,
            tally_id: -1,
        },
    ) {
        this.id = data.id;
        this.boardId = data.board_id;
        this.intro = data.intro;
        this.unit = data.unit;
        this.unitSuffix = data.unitSuffix;
        this.shouldTally = data.shouldTally;
        this.tally = data.tally;
        this.tallyId = data.tally_id;
    }

    getId() {
        return this.id;
    }

    getIntro() {
        return this.intro;
    }

    getUnit() {
        return this.unit;
    }

    getUnitSuffix() {
        return this.unitSuffix;
    }
    

    getShoudlTally() {
        return this.shouldTally;
    }

    getTally() {
        return this.tally;
    }

    getTallyId() {
        return this.tallyId;
    }

    toFormObject() {
        return {
            id: this.id,
            board_id: this.boardId,
            intro: this.intro,
            unit: this.unit,
            unitSuffix: this.unitSuffix,
            shouldTally: this.shouldTally,
            tally: this.tally,
        };
    }
}
